/**
 * 千分符格式化过滤器
 * @param {number|string} value - 要格式化的数字
 * @param {string} affix - 前缀或后缀（默认作为前缀，以':'开头表示后缀）
 * @returns {string} 格式化后的字符串
 */
export function thousandsAdvanced(value, affix = '') {
  if (value === null || value === undefined || value === '') {
    return affix && affix.startsWith(':') ? `0${affix.slice(1)}` : `${affix}0`
  }

  const num = parseFloat(value)
  if (isNaN(num)) {
    return affix && affix.startsWith(':') ? `0${affix.slice(1)}` : `${affix}0`
  }

  // 分割整数和小数部分
  const parts = num.toString().split('.')

  // 处理整数部分，添加千分符
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  let result = parts.join('.')

  // 处理前后缀
  if (affix) {
    if (affix.startsWith(':')) {
      // 以冒号开头表示后缀，如 ':元'
      result = result + affix.slice(1)
    } else {
      // 默认作为前缀，如 '￥'
      result = affix + ' ' + result
    }
  }

  return result
}



// WEBPACK FOOTER //
// ./src/filters/number.js